<template>
    <div id="custom-online">
        <Breadcrumb></Breadcrumb>
        <el-form :model="form" :label-position="labelPosition" ref="form" label-width="100px" :rules="rules" id="form" style="margin-top: 20px">
            <!--产品信息-->
            <el-container>
                <el-main class="main">
                    <el-form-item label="产品分类:" style="margin-top: 20px">
                        <TreeSelect :props="treeSelect" :options="dataList"  v-model="form.typeNo" ref="childSelTree"
                                    style="width: 50%;margin-right: 10px" @getValue="getTreeNodeId"></TreeSelect>
                    </el-form-item>
                    <el-form-item label-width="22px" style="margin-top: 20px">
                        <el-select clearable  v-model="form.timeType" placeholder="请选择" style="width: 100px;margin-right: 20px" size="mini">
                            <el-option
                                    v-for="item in options_1"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <el-date-picker
                                v-model="form.time"
                                type="daterange"
                                align="center"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                        size="mini">
                        </el-date-picker>
                    </el-form-item>
                    <el-divider></el-divider>
                    <el-form-item label="搜索类型:">
                        <el-radio-group v-model="form.searchType" size="small" class="hide_input">
                            <el-radio label="1">标题</el-radio>
                            <el-radio label="2">SKU</el-radio>
                            <el-radio label="3">产品ID</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="搜索内容:">
                        <el-input size="small" v-model="form.searchStr" style="width: 30%;border: 0px;"
                                  placeholder="请输入内容"></el-input>
                        <el-button size="small" type="primary" @click="getList" style="margin-left: 10px">搜索</el-button>
                    </el-form-item>
                    <el-form-item label="排序类型:">
                        <el-radio-group v-model="form.sortType" size="small" class="hide_input">
                            <el-radio label="updateTime">按更新时间</el-radio>
                            <el-radio label="createTime">按创建时间</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div style="margin-bottom: 10px">
                        <el-row>
                            <div style="float: left">
                                <el-dropdown>
                                    <el-button type="primary" size="mini">
                                        批量操作
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item>批量上架</el-dropdown-item>
                                        <el-dropdown-item>批量下架</el-dropdown-item>
                                        <el-dropdown-item>批量删除</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <el-button style="float: right" type="primary" size="mini" @click="createProduct">创建优选商品</el-button>
                        </el-row>
                    </div>
                    <el-row style="height: 40px">
                        <div style="float: left;">
                            <el-radio-group v-model="form.listType" @change="getList">
                                <el-radio-button label="1">在线</el-radio-button>
                                <el-radio-button label="2">已下架</el-radio-button>
                                <el-radio-button label="3">待发布</el-radio-button>
                                <el-radio-button label="4">已删除</el-radio-button>
                            </el-radio-group>
                        </div>
                        <div style="float: right">
                            <pagination
                                    :total="form.total"
                                    :page.sync="form.pageNum"
                                    :limit.sync="form.pageSize"
                                    @pagination="getList"
                            />
                        </div>
                    </el-row>
                    <!--表格-->
                    <div>
                        <el-table id="outTable"  ref="table" border :data="tableData" tooltip-effect="dark" style="width: 100%"
                                  :span-method="arraySpanMethod"  @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="40" align="center"></el-table-column>
                            <el-table-column label="图片" width="120" align="center">
                                <template scope="scope">
                                    <el-popover trigger="hover" title="" placement="right">
                                        <img :src="scope.row.mainPic" style="width: 200px;height: 200px">
                                        <img slot="reference" :src="scope.row.mainPic" style="width: 90px;height: 90px">
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="proTitle" label="标题/产品ID" width="300">
                                <template slot-scope="scope">
                                    <el-row style="text-align: center">{{scope.row.proTitle}}</el-row>
                                    <div style="padding-left: 20px;margin-top: 20px">
                                        <el-row>备注:{{scope.row.remark}}</el-row>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="htmlCode"   label="SKU" align="center">
                                <template slot-scope="scope">
                                    <div v-html="scope.row.htmlCode"></div>
                                </template>
                            </el-table-column>
                            <el-table-column label="价格"  align="center"></el-table-column>
                            <el-table-column label="库存" align="center"></el-table-column>
                            <el-table-column prop="createTime" label="时间" align="center" width="200">
                                <template slot-scope="scope">
                                    <el-row>创建:</el-row>
                                    <el-row>{{scope.row.createTime}}</el-row>
                                    <el-row>更新:</el-row>
                                    <el-row>{{scope.row.updateTime}}</el-row>
                                </template>
                            </el-table-column>
                            <el-table-column prop="handel" label="操作" align="center">
                                <template slot-scope="scope">
                                    <el-button  type="text" size="mini" @click="edit(scope.row)">编辑</el-button><br/>
                                    <el-button  type="text" size="mini" @click="addRemark(scope.row)">添加备注</el-button><br/>
                                    <el-button  type="text" size="mini" @click="addRemark(scope.row)">下架产品</el-button><br/>
                                    <el-button  type="text" size="mini" @click="deleteRow(scope.row)">删除</el-button><br/>
                                </template>
                            </el-table-column>
                            <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
                        </el-table>
                        <pagination
                                :total="form.total"
                                :page.sync="form.pageNum"
                                :limit.sync="form.pageSize"
                                @pagination="getList"
                        />
                    </div>
                </el-main>
            </el-container>
        </el-form>
        <!--添加备注-->
        <el-dialog :close-on-click-modal="false"   title="添加备注" width="35%" :visible.sync="remarkDig">
            <el-row style="display: flex;align-items: center">
                <el-col :span="2">
                    <p>内容:</p>
                </el-col>
                <el-col :span="22">
                    <el-input v-model="form.remark"  placeholder="请输入备注信息" type="textarea" :rows="10">

                    </el-input>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel" size="small">取 消</el-button>
                <el-button type="primary" @click="submitRemark" size="small">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    import ElRow from "element-ui/packages/row/src/row";
    import {calcDescartes,toDecimal} from '@/utils/jn';
    import {goodsUploadImg} from '@/api/product/common';
    import TreeSelect from '@/components/common/treeSelect';
    import {loadDataMap} from '@/api/tree/tree'
    export default {
        name: "product",
        components:{
            ElRow,
            Breadcrumb,
            TreeSelect,
        },
        data(){
            return{
                labelPosition: 'right',
                form:{
                    total:0,
                    pageNum: 1,
                    pageSize: 10,
                    typeNo:null,
                    timeType:'updateTime', //时间类型
                    time:null, //时间值
                    searchType:'1',  //搜索类型
                    searchStr:null, //搜索input框内容
                    sortType:'updateTime', //排序类型
                    listType:'1', //商品搜索状态
                    remark:null,
                },
                tableData:[
                    {
                        mainPic:'https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2853553659,1775735885&fm=26&gp=0.jpg',
                        proTitle:'2K冰丝儿童防蚊裤灯笼裤凉爽舒适夏天男女童薄款宽松休闲裤',
                        remark:'猫猫',
                        createTime:'2020-12-2',
                        updateTime:'2020-12-2',
                        htmlCode:null,
                        skuList:[
                            {
                                skuno:'99',
                                price:'99',
                                invent:'99',
                            },
                            {
                                skuno:'99',
                                price:'99',
                                invent:'99',
                            }
                        ],
                    }
                ],
                innerData: [],
                rules: {
                    name_1: [
                        {required: true, message: '请输入中文标题', trigger: 'blur'},
                    ],
                },
                //产品材质
                options_1: [{
                    value: 'updateTime',
                    label: '更新时间'
                }, {
                    value: 'createTime',
                    label: '创建时间'
                },],
                //下拉树
                treeSelect: {
                    value: 'id',
                    label: 'name',
                    children: 'children',
                },
                //树形数据
                dataList:[],
                //日期控件快捷键
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                ids:[],
                remarkDig:false,
            }
        },
        methods:{
            getList(){
                this.innerData= this.tableData[0].skuList;
                this.Generationhtml(0);
            },
            //加载树形的数据
            loadDataMap(that){
                // 获取本平台树
                loadDataMap().then((res) => {
                    that.dataList=that.optionData(res.data);
                    setTimeout(function () {
                        that.$refs.childSelTree.initHandle();
                    },100);
                })
            },
            //点击舒触发
            getTreeNodeId(val){
            },
            //处理树的数据结构
            optionData(data) {
                let cloneData = JSON.parse(JSON.stringify(data))      // 对源数据深度克隆
                return cloneData.filter(father => {                      // 循环所有项，并添加children属性
                    let branchArr = cloneData.filter(child => father.id == child.parentId);       // 返回每一项的子级数组
                    branchArr.length > 0 ? father.children = branchArr : ''   //给父级添加一个children属性，并赋值
                    return father.parentId == 0;      //返回第一层
                });
            },
            //合并列
            arraySpanMethod: function({row,column,rowIndex,columnIndex}) {
                if (columnIndex === 3) {
                    return [1, 3];
                }else if(columnIndex === 4 || columnIndex === 5){
                    //将合并后的第四、五、六列单元格清除掉，不然后面的单元格会后移
                    return [0, 0];
                }
            },
            //用户勾选
            handleSelectionChange(val) {
                this.ids=[];
                //获取当前用户
                var userName = this.$store.state.user.name;
            },
            //生成表格HTML
            Generationhtml(key){
                // 控制单独的class
                var className = key;
                var tabHtml ='<table class="innerTab" style="width: 100%">'
                this.innerData.forEach((item,index)=>{
                    //转空字符
                    if (item.skuno==null){
                        item.skuno='';
                    }
                    if (item.price==null){
                        item.price='';
                    }
                    if (item.invent==null){
                        item.invent='';
                    }
                    if(index < 5){
                        tabHtml += `<tr>
					<td >`+item.skuno +`</td>
					<td >`+item.price +`</td>
					<td >`+item.invent +`</td>
					                </tr>`;
                    }else{
                        tabHtml += `<tr  style="display: none" class=${className}>
					<td >`+item.skuno +`</td>
					<td >`+item.price +`</td>
					<td >`+item.invent +`</td>
				</tr>`;
                    }

                });
                if(this.innerData.length > 5){
                    tabHtml += `</table><el-row class="tab_butt"><div id="row_bt" onclick="explanRow(${className})">展开<i class="el-icon-caret-bottom"></i></div></el-row>`;
                }else{
                    tabHtml += `</table>`;
                }
                this.tableData[key].htmlCode = tabHtml;
                window.explanRow = function (val) {
                    var flag = $("."+val).is(":hidden");
                    if(flag){
                        $("#row_bt").html(`收起<i class="el-icon-caret-top"></i>`);
                        $("."+val).show();
                    }else{
                        $("#row_bt").html(`展开<i class="el-icon-caret-bottom"></i>`);
                        $("."+val).hide();
                    }
                }
            },
            //取消
            cancel(){
                this.remarkDig=false;
            },
            //添加备注方法
            addRemark(row){
                this.remarkDig=true;
                this.form.remark=row.remark;
            },
            //提交备注
            submitRemark(){
                this.tableData[0].remark=this.form.remark;
                this.cancel();
            },
            //编辑
            edit(row){
                this.$router.push({path:"/product_mng/manage/editWhiteboard",query:{}})
            },
            //删除表格数据
            deleteRow(row){
                this.tableData.splice(0,1);
            },
            //创建优选商品
            createProduct(){
                this.$router.push({path:"/product_mng/manage/createdWhiteboard",query:{}})
            }
        },
        created() {
            var that = this;
            that.loadDataMap(that);
            that.getList();
        }
    }
</script>

<style scoped>
    @import '../../../assets/css/Shopee.css';
    .main{
        border:1px solid darkgrey;
        width: 100%;
    }
</style>
<style>


</style>
